export const themes = ['default-theme', 'light-theme', 'dark-theme'] as const;
export type Theme = typeof themes[number];
